module.exports = __webpack_public_path__ + "img/img-87.e2cede75.png";